import _ from "underscore";

const createUuidGenerator = () => {
    let i = 0
    return () => i++
};

/**
 * Event handlers stack
 */

export class HandlersStack {
    constructor()
    {
        this._stack = []
        this._uuid = createUuidGenerator()
    }

    /**
     * put handler on event into stack
     * @param event {String}
     * @param handler
     * @return {Function} removes handler from stack
     */
    addHandler(event, handler)
    {
        const newId = this._uuid()
        this._stack.push({id: newId, event: event, handler: handler});
        return () => { this._removeHandler(newId) }
    }

    /**
     * delete handler from stack
     * @param id
     */
    _removeHandler(id)
    {
        this._stack = _.filter(this._stack, (handler) => handler.id !== id);
    }

    /**
     * Get last handler for event
     * @param event
     * @return {Function} last handler for event or null
     */
    getLastHandler(event)
    {
        const lastEventHandlerIndex = _.findLastIndex(this._stack, (eventHandler) => eventHandler.event === event)
        return lastEventHandlerIndex >= 0 ? this._stack[lastEventHandlerIndex].handler : null
    }

    /**
     * Get list of event handlers iterator
     * @param event
     * @return {Function} iterator
     */
    getHandlersIterator(event)
    {
        let copy = _.filter(this._stack, (eventHandler) => eventHandler.event === event)

        return () => {
            if (copy.length === 0) {
                return null
            }
            const current = _.last(copy)
            copy = _.initial(copy)
            return current.handler
        }
    }
}

const handlersStack = new HandlersStack()

export default handlersStack


// WEBPACK FOOTER //
// ./web/js/keyHandlers/HandlersStack.js